import React from 'react';
import { FormattedMessage } from 'react-intl';
import Checkbox from '@rio-cloud/rio-uikit/lib/es/Checkbox';
import DeliverableIdFormItem from '~/features/base/components/forms/DeliverableIdFormItem';
import ResultFormItem from '~/features/base/components/forms/ResultFormItem';
import SuggestFormItem from '~/features/base/components/forms/SuggestFormItem';
import DateRangePickerOTA from '~/features/base/components/DateRangePickerOTA/DateRangePickerOTA';
import moment from 'moment';
import { createCustomPresets } from '~/features/base/utils/customPresets';

interface DeviceUpdateEventsFiltersProps {
    filters: any;
    deliverableOptions: any[];
    packageVersionsOptions: any[];
    onDeliverableIdChange: (value: { deliverableId: string }) => void;
    onTargetDeliverableVersionChange: (value: { suggestionId: string }) => void;
    onResultChange: (value: { result: string }) => void;
    onFromToChange: (startValue: any, endValue: any) => void;
    onShowOnlyLastEventChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    clearFilters: () => void;
}

const DeviceUpdateEventsFilters: React.FC<DeviceUpdateEventsFiltersProps> = ({
    filters,
    deliverableOptions,
    packageVersionsOptions,
    onDeliverableIdChange,
    onTargetDeliverableVersionChange,
    onResultChange,
    onFromToChange,
    onShowOnlyLastEventChange,
    clearFilters,
}) => {
    return (
        <div>
            <div className='display-flex gap-10 width-100pct'>
                <div className='width-30pct'>
                    <DeliverableIdFormItem
                        inputClassName='filter-input'
                        value={filters.deliverableId}
                        options={deliverableOptions}
                        onChange={onDeliverableIdChange}
                    />
                </div>
                <div className='width-20pct'>
                    <SuggestFormItem
                        disabled={!filters.deliverableId}
                        value={filters.targetDeliverableVersion}
                        label='intl-msg:targetVersion'
                        options={packageVersionsOptions}
                        onChange={onTargetDeliverableVersionChange}
                    />
                </div>
                <div className='width-20pct'>
                    <ResultFormItem value={filters.result} onChange={onResultChange} />
                </div>
                <div className='width-25pct padding-top-25'>
                    <Checkbox
                        onClick={onShowOnlyLastEventChange}
                        checked={filters.showOnlyLastEvent}
                        size='large'
                    >
                        <label className='control-label'>
                            <FormattedMessage id='intl-msg:showLatestUpdateEvents.label' />
                        </label>
                    </Checkbox>
                </div>

            </div>
            <div className='display-flex gap-10 width-100pct margin-top-10 justify-content-between'>
                <div>
                    <label className='control-label'>
                        <FormattedMessage id='intl-msg:range'/>
                    </label>
                    <DateRangePickerOTA
                        hasTimePicker={true}
                        customPresets={createCustomPresets()}
                        startValue={filters.from ? moment(parseInt(filters.from, 10)) : null}
                        endValue={filters.to ? moment(parseInt(filters.to, 10)) : null}
                        onRangeChange={onFromToChange}
                        onClear={() => onFromToChange(undefined, undefined)}
                        clearable
                    />
                </div>
                <div className='padding-top-25'>
                    <a
                        id='clear-filters-button'
                        className='btn btn-default width-200'
                        onClick={clearFilters}
                    >
                        <span className='rioglyph rioglyph-trash' aria-hidden='true'></span>&nbsp;
                        <FormattedMessage id='intl-msg:clearFilters' />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default DeviceUpdateEventsFilters;
